import React, { Component } from 'react';

import { Container } from '@mui/material';

import * as libRegions from '@luxuryescapes/lib-regions';

import OfferBreadcrumbs from '~/components/Common/Elements/OfferBreadcrumbs';

import TENANTS from '../../../consts/tenant';
import OffersService from '../../../services/OffersService';
import Asinc from '../../Common/Asinc';

import SchedulesPage from './SchedulesPage';

interface ScheduleEditContainerProps {
  match: {
    params: {
      id_offer: string;
      brand: string;
    };
  };
}

export default class ScheduleEditContainer extends Component<ScheduleEditContainerProps> {
  fetchData() {
    const { match } = this.props;
    const { id_offer: offerId } = match.params;

    return OffersService.getOffer(offerId);
  }

  render() {
    const { match } = this.props;
    const { id_offer: offerId, brand } = match.params;

    const tenant = TENANTS[Object.keys(TENANTS).find((k) => TENANTS[k].brand === brand)];

    return (
      <Container maxWidth="xl">
        <OfferBreadcrumbs offerId={offerId} currentPage="Schedules" />
        <h1 className="page-header">Edit Offer Schedules for {tenant.title}</h1>
        <Asinc
          promise={this.fetchData()}
          then={(response) => (
            <SchedulesPage brand={tenant.brand} offer={response.result} regions={libRegions.getRegions()} />
          )}
        />
      </Container>
    );
  }
}
